const theme = {
	accent: '#81e291',
	background: '#00242c',
	darkBg: '#00131b',
	movieBackground: '#003440',
	light: '#efe',
	faded: '#9a9',
	shadow: '0 0 5px rgba(0, 0, 0, 0.7)',
	badgeRed: '#f24',
	badgeBlue: '#15f',
	youTube: '#f23'
}

export default theme;